import React from 'react';

// stylesheet
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>2023 All Rights Reserved. Created by Khusniddin Ismoilov. </p>
  </footer>
);
export default Footer;
